/**
 * Bank detail normalization for the workshop's own invoice details (#2461).
 *
 * Deliberately forgiving. These values are printed on the invoice and the
 * IBAN gates finalization, so the cost of wrongly rejecting a valid account
 * is far higher than the cost of storing an odd-looking one: a workshop that
 * cannot save its IBAN cannot invoice at all. We therefore normalize
 * presentation (spacing, case) and leave validity to the bank — no mod-97
 * check as a blocking error, and no country allowlist, since foreign accounts
 * are legitimate.
 */

/**
 * Strips the grouping spaces people paste from their bank's UI and uppercases
 * the country prefix. `FI21 1234 5600 0007 85` and `fi2112345600000785` both
 * become `FI2112345600000785`.
 */
export function normalizeIban(value: string): string {
  return value.replace(/[\s\u{00a0}-]/gu, '').toUpperCase();
}

/** BIC is always uppercase and never contains spaces. */
export function normalizeBic(value: string): string {
  return value.replace(/[\s\u{00a0}]/gu, '').toUpperCase();
}
